<app-table [data]="machines$ | async" [isDeletable]="true" [columns]="columns" [addLink]="'add'" [editLink]="'edit'" (deleteRowEvent)="deleteMachine($event)"></app-table>
<router-outlet></router-outlet>